export default __webpack_public_path__ + "static/media/romango-mobile-1.48f6b981.png";